import type { Session } from "../types/catalog";

export const fallbackSession: Session = {
  email: null,
  role: "customer",
  accessAuthenticated: false,
  adminEmailsConfigured: false,
};

export function sessionFromApi(value: unknown): Session {
  if (typeof value !== "object" || value === null) {
    return fallbackSession;
  }

  const candidate = value as Partial<Session>;
  const role = candidate.role === "admin" ? "admin" : "customer";
  const email = typeof candidate.email === "string" ? candidate.email : null;

  return {
    email,
    role,
    accessAuthenticated:
      typeof candidate.accessAuthenticated === "boolean"
        ? candidate.accessAuthenticated
        : Boolean(email),
    adminEmailsConfigured:
      typeof candidate.adminEmailsConfigured === "boolean"
        ? candidate.adminEmailsConfigured
        : false,
  };
}
